module.exports = require('./helpers/bundle-url').getBundleURL('8aiQJ') + "Flick.56fa6b53.gif";